import { DEFAULT_CENSOR_MASK } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { mutateObject } from 'cpool-utils';
import { z } from 'zod';

import type { EventSchema } from '../../../utils/EventSchema';
import { _Event } from '../../_Event';

export class LoanRequest_ApplicantNoteAdded extends _Event {
    constructor(payload: EventSchema<LoanRequest_ApplicantNoteAdded>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            applicantId: schemaId,
            author: z.object({
                firstName: z.string(),
                id: schemaId,
                lastName: z.string(),
            }),
            content: z.string().min(1),
            favored: z.boolean().default(false),
            id: schemaId,
        });
    }

    static example(): EventSchema<LoanRequest_ApplicantNoteAdded> {
        return {
            applicantId: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
            author: {
                firstName: 'Max',
                id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
                lastName: 'Mustermann',
            },
            content: 'This is a valid note content.',
            favored: false,
            id: '7f2def23-f1ad-4c6b-9c84-1218e0c794e7',
        };
    }

    static exampleCensored(): EventSchema<LoanRequest_ApplicantNoteAdded> {
        return {
            ...LoanRequest_ApplicantNoteAdded.example(),
            content: DEFAULT_CENSOR_MASK,
        };
    }

    getCensoredSchema() {
        return this.getSchema().transform((data) => {
            return mutateObject(data, {
                content: DEFAULT_CENSOR_MASK,
            });
        });
    }
}
